// /src/store/reducers/authReducer.js
import { createSlice } from "@reduxjs/toolkit";
import { loginUser } from "../actions/authActions";

// todo: move to authActions and also check for token expiration.
const token = localStorage.getItem("token");

const initialState = {
  isAuthenticated: !!token,
  isGlobalLoader: false,
  user: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
    },
    setAuthenticated(state, action) {
      state.isAuthenticated = action.payload;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { logout, setAuthenticated, setUser } = authSlice.actions;
export default authSlice.reducer;
